'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHiddenNamespace = getHiddenNamespace;
function getHiddenNamespace(prefix) {
  var withPrefix = prefix ? prefix + 'Hidden' : 'hidden';
  return withPrefix;
}